import { render } from "./BuildingEditModal.vue?vue&type=template&id=c3482580&scoped=true"
import script from "./BuildingEditModal.vue?vue&type=script&lang=js"
export * from "./BuildingEditModal.vue?vue&type=script&lang=js"

import "./BuildingEditModal.vue?vue&type=style&index=0&id=c3482580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3482580"]])

export default __exports__